// Shared branded loading state — a scooter riding along a dashed route,
// used everywhere a page/section shows "Loading..." so it reads the same
// throughout the app instead of each page inventing its own spinner/text.
export default function LoadingIndicator({ label = "Loading...", compact = false }) {
  return (
    <div className="loading-indicator" style={compact ? { padding: "12px 0" } : undefined}>
      <div className="loading-track">
        <span className="loading-vehicle" role="img" aria-label="Loading">🛵</span>
      </div>
      <p className="hint" style={{ marginTop: "10px" }}>{label}</p>
    </div>
  );
}
